import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M23.5 3.5c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20m0-2.5C11.1 1 1 11.1 1 23.5S11.1 46 23.5 46 46 35.9 46 23.5 35.9 1 23.5 1z"
		}),
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M31.6 10.6l-2.3 1.6c-1.7-.9-3.7-1.4-5.8-1.4-7 0-12.7 5.7-12.7 12.7 0 3.8 1.7 7.3 4.5 9.7.5.5.6 1.2.2 1.8-.4.5-1.2.6-1.8.2-3.5-2.9-5.4-7.1-5.4-11.7 0-8.4 6.8-15.2 15.2-15.2 3 0 5.7.8 8.1 2.3z"
		}), /* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M38.7 23.5c0 4.5-2 8.8-5.4 11.7-.2.2-.5.3-.8.3-.4 0-.7-.2-1-.5-.4-.5-.4-1.3.2-1.8 2.9-2.4 4.5-6 4.5-9.7 0-2.1-.5-4.1-1.4-5.8l1.6-2.3c1.5 2.4 2.3 5.1 2.3 8.1z"
		})] }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M35.4 11.6l-10.3 7.2c-.5-.2-1-.3-1.6-.3-1.3 0-2.6.5-3.5 1.5-1 .9-1.5 2.2-1.5 3.5 0 .5.1 1 .3 1.5l-3 2c-.8.5-.9 1.6-.2 2.2l2.2 2.2c.6.6 1.7.5 2.2-.2l2-3c.5.2 1 .3 1.5.3 1.3 0 2.6-.5 3.5-1.5s1.5-2.2 1.5-3.5c0-.5-.1-1.1-.3-1.6l7.2-10.3zM24.9 24.9c-.8.8-2.1.8-2.8 0-.4-.4-.6-.9-.6-1.4s.2-1 .6-1.4c.4-.4.9-.6 1.4-.6s1 .2 1.4.6.6.9.6 1.4-.2 1-.6 1.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M27.6 38.9h-8.2c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2h8.2c.7 0 1.2.6 1.2 1.2s-.5 1.2-1.2 1.2z"
		})
	]
});
export default SvgIcon;
